<template>
  <button-vue :label="isLoading ? 'Adding' : 'Add to basket'" type="submit" v-bind="buttonProps"
              v-on:click="handleAddClick"/>

  <modal
      :title="!data?.error ? 'Item added to basket' : 'There was a problem'"
      :icon="!data?.error ? 'check-circle-outline' : 'error-outline'"
      :show="showModal"
      @close="handleClose"
      :isMini="true">
    <div v-if="!data.error">
      <div class="AddedToBasket-content">
        <img class="AddedToBasket-img" :src="data.thumb" alt="">
        <div class="AddedToBasket-body">
          <h5 class="AddedToBasket-name">{{ data.name }}</h5>
          <p class="AddedToBasket-desc" v-if="data.desc">
            {{ data.desc }}
          </p>

          <div class="AddedToBasket-price">
            <strong>{{ data.price }}</strong> <s>{{ data.beforePrice }}</s>
          </div>
        </div>
      </div>

      <div class="AddedToBasket-footer">
        <div class="AddedToBasket-footerTotals">
          <p class="AddedToBasket-footerTotalItems">Basket: {{ data.basketCount }} items</p>
          <p class="AddedToBasket-footerTotalPrice">Total: {{ data.baseTotal }}</p>
        </div>

        <div class="AddedToBasket-footerButtons">
          <button-vue class="AddedToBasket-button" label="Continue shopping" type="button" @click="handleContinueClick"
                      :isPrimary="false" :isBlock="true"/>
          <button-vue class="AddedToBasket-button" label="Checkout now" href="/basket" :isPrimary="true"
                      :isBlock="true"/>
        </div>
      </div>
    </div>

    <alert v-else>
      There was a problem adding to basket, please try again.
    </alert>
  </modal>
</template>

<script>
import Modal from '../UI/Modal.vue';
import ButtonVue from '../UI/Button.vue';
import Alert from '../UI/Alert.vue';
import {fetcher} from '../../../../utils/fetcher';

export default {
  components: {Modal, ButtonVue, Alert},

  data: () => ({
    showModal: false,
    isLoading: false,
    data: null
  }),

  methods: {
    async handleAddClick(e) {
      e.preventDefault();

      const setLoading = setTimeout(() => {
        this.isLoading = true
      }, 300);
      
      try {
        const responseGet = await fetcher.get(this.url);

        const payload = {
          productId: this.productId,
          quantity: this.quantity
        };

        const response = await fetcher.post(responseGet.url, payload)
        this.$store.commit('basket/setQuantity', response.basketCount);
        this.data = response;

        // Raise an event for conversion tracking to intercept
        document.dispatchEvent(new CustomEvent('addBasket', {
          detail: payload,
        }));
      } catch (e) {
        console.log('Error adding to basket', e);
        this.data = {error: e}
      }

      clearTimeout(setLoading);
      this.isLoading = false;
      this.showModal = true;
    },

    handleContinueClick() {
      this.showModal = false;
    },

    handleClose() {
      this.showModal = false;
    }
  },

  props: {
    productId: {
      type: Number,
      default: null
    },
    quantity: {
      type: Number,
      default: 1
    },
    url: {
      type: String,
      default: '/api/basket/add'
    },
    buttonProps: {
      type: Object,
      default: () => ({
        isPrimary: true,
        isBlock: true
      })
    }
  }
}
</script>